module.exports = __webpack_public_path__ + "static/media/SatelliteChat.d2809660.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/SatelliteChat.png
// module id = 45
// module chunks = 0